import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <div className="separator" />
      <div className="footerContentContainer">
        <div>
          Interested in my portfolio? <br />
          Feel free to contact me! <br />
          Mail: dawidzlobecki2@gmail.com <br />
          Phone: +48 516 660 319
        </div>
      </div>
    </div>
  );
};

export default Footer;
